<app-modal-title>{{getTitle()}}</app-modal-title>
<app-modal-body>
  <div [ngStyle]="{'height': height}">
    <div class="ot-panel__header">
      <app-tabs [identifier]="'activity-deployment-step-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="tabs"
        [color]="TabColor.SECONDARY" [selectedIndex]="activeTab"></app-tabs>
    </div>
    @if (activeTab === ActivityDeploymentStepTab.GENERAL) {
    <div id="otsc-activity-execution-step-details-general" class="otsc-activities-section">
      <div class="otsc-activities-section-title ot-pt-1 ot-pl-3 ot-pr-3" i18n>General</div>
      <div class="otsc-metadata ot-pt-1 ot-pb-1 ot-pl-4 ot-pr-2">
        <div class="ot-row">
          <div class="ot-row__column otsc-metadata-key">
            <small class="ot--has-text-muted" i18n>Name</small>
          </div>
          <div class="ot-row__column otsc-metadata-value">
            <p>{{step.nickname}}</p>
          </div>
        </div>
        <div class="ot-row">
          <div class="ot-row__column otsc-metadata-key">
            <small class="ot--has-text-muted" i18n>Plug-in</small>
          </div>
          <div class="ot-row__column otsc-metadata-value">
            <p>{{step.plugin}}</p>
          </div>
        </div>
        <div class="ot-row">
          <div class="ot-row__column otsc-metadata-key">
            <small class="ot--has-text-muted" i18n>Current status</small>
          </div>
          <div class="ot-row__column otsc-metadata-value">
            <p>
              <i class="otsc-deployement-step-status-icon" [title]="stepStatus.altText"
                [class]="stepStatus.className"></i>
            </p>
          </div>
        </div>
        <div class="ot-row">
          <div class="ot-row__column otsc-metadata-key">
            <small class="ot--has-text-muted" i18n>Error</small>
          </div>
          <div class="ot-row__column otsc-metadata-value">
            <p>{{step.status?.errorMessage}}</p>
          </div>
        </div>
      </div>
    </div>
    }
    @if (activeTab === ActivityDeploymentStepTab.PARAMETERS) {
    <div id="otsc-activity-execution-step-details-params" class="otsc-activities-section">
      <div class="otsc-activities-section-title ot-pt-1 ot-pl-3 ot-pr-3" i18n>Parameters</div>
      <div class="otsc-metadata ot-pt-1 ot-pb-1 ot-pl-3 ot-pr-3 table-container">
        <app-datatable [identifier]="dlgId" [isSortable]="true" [cols]="col" [rows]="row"
          (onclickcolumn)="sortParameters($event)"></app-datatable>
      </div>
    </div>
    }
  </div>
</app-modal-body>
<app-modal-footer>
  <button class="ot-btn ot-btn--is-primary" i18n-title title="Close" (click)="close()" i18n>
    Close
  </button>
</app-modal-footer>